import { useState } from "react";
import { useRule } from "../CreateRuleNew/RuleReducer";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import Button3 from "../../../Button/Button3";
import classes from "./RuleWizard.module.css";

const WizardStepAnythingElse = ({ onNext, onSkip, onBack }) => {
    const { state, dispatch } = useRule();
    const [wantsMore, setWantsMore] = useState(() => (
        state.conditions.some((c) => c.is_deadline_condition) ? true : null
    )); // null | true | false

    const formatMsDuration = (ms) => {
        if (ms < 1000) return `${ms}ms`;
        const seconds = ms / 1000;
        if (seconds <= 60) return `${seconds} second`;
        const minutes = seconds / 60;
        return `${minutes} minute`;
    };

    return (
        <>
            <div className={classes.contentHeader}>
                <h2 className={classes.contentTitle}>Does anything else have to be true before the rule can fire?</h2>
                <p className={classes.contentSubtitle}>
                    {`${state.timeframe_window_ms > 0 ? `This is an optional time based status check. At the end of the ${formatMsDuration(state.timeframe_window_ms)} window the rule will only fire if the chosen outputs/inputs are in the required states. ` : "This is an optional time based status check. You will define a window and certain output or input states. The rule will only fire once this window is complete and the chosen outputs/inputs are in the required states. "}`}
                </p>
            </div>

            <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "12px" }}>
                <div
                    style={{
                        display: "flex", alignItems: "center", gap: "14px", padding: "16px 18px",
                        border: `2px solid ${wantsMore === true ? "var(--Primary-Color)" : "#e0e0e0"}`,
                        borderRadius: "8px", cursor: "pointer",
                        background: wantsMore === true ? "rgba(var(--Primary-Color-RGB, 33,150,243), 0.05)" : undefined,
                    }}
                    onClick={() => setWantsMore(true)}
                >
                    <Checkbox checked={wantsMore === true} onChange={() => {}} />
                    <div>
                        <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#2d2d2d" }}>Yes</p>
                        <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#9e9e9e" }}>Check the status of other switches before the rule fires</p>
                    </div>
                </div>

                <div
                    style={{
                        display: "flex", alignItems: "center", gap: "14px", padding: "16px 18px",
                        border: `2px solid ${wantsMore === false ? "var(--Primary-Color)" : "#e0e0e0"}`,
                        borderRadius: "8px", cursor: "pointer",
                        background: wantsMore === false ? "rgba(var(--Primary-Color-RGB, 33,150,243), 0.05)" : undefined,
                    }}
                    onClick={() => setWantsMore(false)}
                >
                    <Checkbox checked={wantsMore === false} onChange={() => {}} />
                    <div>
                        <p style={{ margin: 0, fontWeight: 600, fontSize: "14px", color: "#2d2d2d" }}>No</p>
                        <p style={{ margin: "3px 0 0 0", fontSize: "12px", color: "#9e9e9e" }}>That's everything this rule needs</p>
                    </div>
                </div>

                {wantsMore === true && (
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "10px" }}>
                        <p style={{ margin: 0, color: "#6e6e6e", fontSize: "14px", fontWeight: 600 }}>
                            Should these be combined with AND or OR?
                        </p>
                        <div style={{ display: "flex", gap: "8px" }}>
                            <Button3
                                style={{
                                    flex: 1, minHeight: "40px",
                                    backgroundColor: state.deadline_logic_operator === "AND" ? "var(--Primary-Color)" : undefined,
                                    color: state.deadline_logic_operator === "AND" ? "white" : undefined,
                                }}
                                onClick={() => dispatch({ type: "SET_DEADLINE_LOGIC_OPERATOR", payload: "AND" })}
                            >
                                AND — all must be true
                            </Button3>
                            <Button3
                                style={{
                                    flex: 1, minHeight: "40px",
                                    backgroundColor: state.deadline_logic_operator === "OR" ? "var(--Primary-Color)" : undefined,
                                    color: state.deadline_logic_operator === "OR" ? "white" : undefined,
                                }}
                                onClick={() => dispatch({ type: "SET_DEADLINE_LOGIC_OPERATOR", payload: "OR" })}
                            >
                                OR — any can be true
                            </Button3>
                        </div>
                        <p style={{ margin: 0, fontSize: "12px", color: "#9e9e9e" }}>
                            This is separate from the AND/OR setting for your main conditions.
                        </p>
                    </div>
                )}
            </div>

            <div className={classes.navRow}>
                <Button label="Back" icon="pi pi-arrow-left" severity="secondary" outlined onClick={onBack} />
                <Button
                    label="Next"
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    severity="success"
                    disabled={wantsMore === null}
                    onClick={() => (wantsMore ? onNext() : onSkip())}
                />
            </div>
        </>
    );
};

export default WizardStepAnythingElse;
